import React, {PureComponent} from 'react';
import Sizes from "../Assets/Sizes";
import {CSSTransition, TransitionGroup} from "react-transition-group";
import {isFunction, toInitials} from "../Common/Helpers";
import {FormattedMessage} from "react-intl";
import {Checkbox} from "rmwc";
import QuantityPicker from "./QuantityPicker";
import AutoHeightNotifier from "./AutoHeightNotifier";
import {Avatar} from "@agney/react-avatar";
import styled, {withTheme} from "styled-components";
import InfoIcon from '@material-ui/icons/InfoOutlined';
import {isNonEmptyString} from "@tomeravni/easybizy-js-common/common";
import {DEFAULT_SVG_ICON_SIZE} from "../Common/constants";


const SelectItemWrapper = styled.button`
    box-shadow: ${p => p.theme.colors.defaultBoxShadow};
    border: none;
    width: 100%;
    padding: ${p => p.compact ? Sizes.mediumPadding : Sizes.defaultPadding} ${Sizes.defaultPadding};
    border-radius: ${Sizes.listItemBorderRadius};
    background: ${p => p.theme.colors.surfaceFront};
    margin-top: ${Sizes.defaultPadding};
    text-align: right;
    text-align: start;
    color: ${p => p.theme.colors.safeText};
    font-size: 1.1rem;
    -webkit-user-select: none; /* Chrome all / Safari all */
    -moz-user-select: none; /* Firefox all */
    -ms-user-select: none; /* IE 10+ */
    user-select: none; /* Likely future */
    ${props => props.minHeight && `min-height: ${Sizes.largeIcon}`}
    outline: ${props => props.selected ? `3px solid ${props.theme.colors.primaryText}` : '3px solid transparent'};

    .MuiSvgIcon-root {
        fill: ${p => p.theme.colors.safeText};
    }
`;

const SelectItemContent = styled.div`
    display: flex;
    justify-content: ${props => (props.justify ? props.justify : 'space-between')};
    align-items: center;
    flex-grow: 1;
`;

const ItemIcon = styled.img`
    height: 25px;
    width: 25px;
`;

const SelectItemLabel = styled.div`
    font-weight: ${props => props.important ? 'bold' : 'normal'};
    margin-right: ${props => props.margin ? Sizes.mediumPadding : 0};
    margin-left: ${props => props.margin ? Sizes.mediumPadding : 0};
    display: flex;
    align-items: center;
    min-height: 30px;

`;

const SubLabel = styled.div`
    text-align: ${p => p.sublabelLeft ? 'left' : 'initial'};
    direction: ${p => p.sublabelLeft ? 'ltr' : 'initial'};
    padding-left: ${Sizes.mediumPadding};
    padding-right: ${Sizes.mediumPadding};
`;

const InfoButton = styled.button`
    background: transparent;
    box-shadow: none;
    border: black;
    padding: 5px 10px; /*We do this to make clicking easier*/
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${p => p.theme.colors.safeText};

    > svg {
        font-size: 1rem;
        fill: ${p => p.theme.colors.safeText};
    }
`

const PaddedStart = styled.div`
    margin-inline-start: ${Sizes.mediumPadding};
`

const SelectItemContentWrapper = styled.div`
    display: flex;
    align-items: center;

    .ent-enter {
        opacity: 0;
        max-width: 0;
    }

    .ent-enter-active {
        opacity: 1;
        max-width: 100px;
        transition: all 300ms;
    }

    .ent-exit {
        opacity: 1;
        max-width: 100px;
    }

    .ent-exit-active {
        opacity: 0;
        max-width: 0;
        transition: all 300ms;
    }

    overflow: hidden;
`;

const ShrinkableDiv = styled.div`
    transition: all 300ms;
    ${p => p.shirnked && 'max-width: 10px;'}
    ${p => p.shirnked && 'opacity: 0;'}
    ${p => p.shirnked && 'overflow: hidden;'}

`;

const Wrapped = styled.div`
    display: flex;
    align-items: center;
`

const SvgIcon = (str, fill, customSize) => {
    const customStyles = {
        position: 'relative',
        height: customSize || DEFAULT_SVG_ICON_SIZE, width: customSize || DEFAULT_SVG_ICON_SIZE
    }

    if (isNonEmptyString(fill)) {
        customStyles.fill = fill;
    }

    return <div style={customStyles} dangerouslySetInnerHTML={{__html: str}}/>;
}


const SecondLineWrapper = styled.div`
    overflow: hidden;

    .expand-enter {
        opacity: 0;
        height: 0;
    }

    .expand-enter-active {
        opacity: 1;
        height: 100%;
        transition: all 300ms ease-out;
    }

    .expand-exit {
        opacity: 1;
        height: 100%;
    }

    .expand-exit-active {
        opacity: 0;
        max-height: 0;
        transition: all 300ms ease-in;
    }

`


class SelectItem extends PureComponent {
    state = {
        showDescription: false
    }

    changeQuantity = (item, add) => {
        this.props.changeQuantity(item, add);
    }

    toggleDescription = (ev) => {
        ev.stopPropagation();
        ev.preventDefault();
        this.setState({showDescription: !this.state.showDescription});
    }

    render() {
        const {
            item,
            selected,
            unique,
            transitionDelay,
            nameProp,
            subLabalProp,
            sublabelLeft,
            multiSelect,
            scrollToTop,
            onClick,
            theme,
            quantity,
            showImage,
            enableQuantitySelectionForItem,
            resolveItemDescription
        } = this.props;

        const key = '_key_' + unique;

        let sublabel, label, description;
        if (subLabalProp) {
            sublabel = isFunction(subLabalProp) ? subLabalProp(item) : item[subLabalProp];
        }

        if (nameProp) {
            label = isFunction(nameProp) ? nameProp(item) : item[nameProp];
        } else {
            label = item.name;
        }

        if (isFunction(resolveItemDescription)) {
            description = resolveItemDescription(item);
        }

        let initials = toInitials(label);

        if (item.translateName) {
            label = <FormattedMessage id={label}/>
        }

        let backgroundColor = theme.colors.surfaceFront;
        const multiItemsEnabled = selected && isFunction(enableQuantitySelectionForItem) && enableQuantitySelectionForItem(item);
        let checkboxEl = (<span key='irrelevant'></span>);
        if (multiSelect) {
            checkboxEl = (<CSSTransition timeout={300}
                                         in={true}
                                         classNames="ent"
                                         mountOnEnter
                                         unmountOnExit
                                         key={key + '2'}>
                <ShrinkableDiv shirnked={multiItemsEnabled}>
                    <Checkbox key={key + 'checkbox'}
                              checked={!!selected}
                              onChange={() => onClick(item)}>
                    </Checkbox>
                </ShrinkableDiv>
            </CSSTransition>);
        }


        const rightSideItems = [];
        if (multiItemsEnabled) {
            rightSideItems.push(<CSSTransition timeout={300}
                                               in={true}
                                               classNames="ent"
                                               mountOnEnter
                                               unmountOnExit
                                               key={key + 'quantity'}>
                    <QuantityPicker changeQuantity={(add) => this.changeQuantity(item, add)}
                                    quantity={quantity}></QuantityPicker>
                </CSSTransition>
            );

            if (!multiSelect) {
                label = <PaddedStart>{label}</PaddedStart>
            }
        }

        rightSideItems.push(checkboxEl);
        let secondLineEl = isFunction(this.props.resolveItemSecondLine) ? this.props.resolveItemSecondLine(item) : undefined;
        const selectItem = (
            <SelectItemWrapper key={key}
                               className="items-picker__item"
                               onClick={this.props.onClick.bind(this, item)}
                               backgroundColor={backgroundColor}
                               compact={multiSelect}
                               enableQuantitySelection={multiItemsEnabled}
                               quantitySelected={item.quantitySelected}
                               minHeight={item.icon}
                               selected={selected && !multiSelect}
                               style={{'transitionDelay': `${transitionDelay}ms`}}>
                <SelectItemContentWrapper>
                    <SelectItemContent justify={(item.icon || showImage) && 'flex-start'}>
                        {item.icon && (!item.isSvg ? <ItemIcon src={item.icon}/> :
                            SvgIcon(item.icon, theme.colors.safeText, item.customSize))}
                        {/*{item.icon && <ItemIcon src={item.icon}/>}*/}
                        {showImage && !item.isSvg && <Avatar
                            bgColor={this.props.theme.colors.textOnBackgroundImage || this.props.theme.colors.surfaceTop}
                            htmlWidth='40px'
                            textColor={this.props.theme.colors.primaryText}
                            src={item.image}
                            text={initials}
                        />}
                        <SelectItemLabel {...item} margin={!multiSelect} className="select-item-label">
                            <Wrapped>
                                <TransitionGroup
                                    component={null}
                                    transitionEnterTimeout={300}
                                    transitionLeaveTimeout={300}>
                                    {rightSideItems}
                                </TransitionGroup>
                            </Wrapped>
                            {label}{description && <InfoButton onClick={this.toggleDescription}><InfoIcon
                            style={{color: 'initial'}}/></InfoButton>}
                        </SelectItemLabel>


                        {sublabel && <SubLabel sublabelLeft={sublabelLeft}>{sublabel}</SubLabel>}
                    </SelectItemContent>
                </SelectItemContentWrapper>
                <SecondLineWrapper>
                    {description && <AutoHeightNotifier>
                        {this.state.showDescription && description}
                    </AutoHeightNotifier>}

                    <AutoHeightNotifier>
                        {secondLineEl}
                    </AutoHeightNotifier>
                </SecondLineWrapper>

            </SelectItemWrapper>);

        if (scrollToTop) {
            return selectItem;
        } else {
            return (<CSSTransition
                in={true}
                timeout={{enter: 500 + transitionDelay}}
                classNames={`fade${this.props.scrollToTop ? '-only' : ''}`}
                mountOnEnter
                unmountOnExit
                key={key}>
                {selectItem}
            </CSSTransition>);
        }

    }
}

export default withTheme(SelectItem);
